"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var react_redux_1 = require("react-redux");
var state_1 = require("../../shared/booking_widget/state");
var store_1 = require("../../shared/state/store");
var http_client_1 = require("../http_client");
function initializeBookingWidget(apiBaseUrl) {
    var rootNode = document.querySelector('[data-v16-booking-widget-slot]');
    if (rootNode) {
        require.ensure([
            '../../shared/booking_widget/index',
        ], function () {
            var AppContainer = require('../../shared/booking_widget/index').BookingWidgetContainer;
            var store = store_1.createAppStore({
                booking: {
                    apiBaseUrl: apiBaseUrl,
                    httpClient: http_client_1.httpClient,
                },
            });
            // tslint:disable-next-line:no-any
            window.__showOfferBookingButton = function (data, node, isBooked) {
                store.dispatch(state_1.upgradeBookingData(data, node, isBooked));
            };
            react_dom_1.render(React.createElement(react_redux_1.Provider, { store: store },
                React.createElement(AppContainer, null)), rootNode);
        });
    }
}
exports.initializeBookingWidget = initializeBookingWidget;



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/booking_wiget.tsx
// module id = 248
// module chunks = 2